import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@freelancer/pipes';
import { UiModule } from '@freelancer/ui';
import { GiveGetReferralListComponent } from './give-get-referral-list.component';

@NgModule({
  imports: [CommonModule, UiModule, PipesModule],
  declarations: [GiveGetReferralListComponent],
  exports: [GiveGetReferralListComponent],
})
export class GiveGetReferralListModule {}
